/**
 * Pill — small status pill. Variants map to brand tokens only.
 * `tone`: brand (primary), accent, secondary, neutral, success (brand blue),
 * or a custom tint pair.
 */
import type { ReactNode } from "react";

type PillTone = "brand" | "secondary" | "accent" | "neutral" | "success";

interface PillProps {
  children: ReactNode;
  tone?: PillTone;
  /** Solid filled pill (white text on brand fill) instead of soft tint */
  solid?: boolean;
  className?: string;
}

const SOFT: Record<PillTone, string> = {
  brand: "bg-genie-primary/10 text-genie-primary",
  secondary: "bg-genie-secondary/10 text-genie-secondary",
  accent: "bg-genie-accent/15 text-genie-accent-dark",
  neutral: "bg-gray-100 text-gray-600",
  success: "bg-genie-success/10 text-genie-success",
};

const SOLID: Record<PillTone, string> = {
  brand: "bg-genie-primary text-white",
  secondary: "bg-genie-secondary text-white",
  accent: "bg-genie-accent text-white",
  neutral: "bg-gray-500 text-white",
  success: "bg-genie-success text-white",
};

export const Pill = ({ children, tone = "brand", solid = false, className }: PillProps) => {
  return (
    <span
      className={`inline-flex items-center h-[26px] px-3 rounded-full text-[12.5px] font-bold ${
        solid ? SOLID[tone] : SOFT[tone]
      } ${className ?? ""}`}
    >
      {children}
    </span>
  );
};

export default Pill;
